module.exports = __webpack_public_path__ + "img/course-icon-up.73d1a953.svg";